<template>
  <div
    id="testimonialjoinus"
    class="lg:pb-12 md:pb-0 lg:pt-10 md:pt-10 lg:px-0 md:px-0 px-4"
  >
    <TestimonialDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />
    <Testimonialpopup
      :isActive="isLeaveActive"
      :selectTesimonial="selectTesimonial"
      @close="handleLeave"
    />
    <!-- <div class="relative flex">
      <div class="absolute bg-designGT">
        <img src="../../../assets/images/bg-des/bgdTG.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design-dots-tsm">
        <img src="../../../assets/images/Ellipse 12.svg" alt="bg-polygon" />
      </div>
    </div> -->
    <div class="flex justify-center mb-10">
      <div>
        <p
          class="text-center title sm-fsize16 md:font-normal lg:font-normal font-bold lg:pb-0 md:pb-0 pb-4"
        >
          Testimonials
        </p>
        <p class="fsize18 mb-4">
          Here are some of the testimonials we have received on our impact from
          individuals and organisations.
        </p>
        <div class="flex justify-center" @click="handleLeave">
          <b-button
            variant="primary"
            class="lg:px-12 md:px-12 lg:py-3 md:py-3 sm-fsize14 fsize16"
          >
            Leave a Testimonial</b-button
          >
        </div>
      </div>
    </div>
    <div class="example-3d">
      <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide
          class="sm-h-auto cursor-pointer"
          v-for="(item, index) in testimonials.result"
          :key="'swiper-slide-' + index"
        >
          <div
            class="w-full lg:p-8 md:p-4 p-4 cust-bg"
            @click="toggleDetails(true, item)"
          >
            <div class="" @mouseover="mouseover" @mouseleave="mouseleave">
              <p
                class="pt-2 clr777 font-normal fsize16px italic ellipsis-9 md-ellipsis-6 lineclamp-5"
              >
                <!-- <img :src="quotesImgopen" alt="quotesimg" class="w-4 h-4" /> -->
                <span class="text-0193a1 fsize25 lineclamp-5"> ❝</span>
                {{ item.description }}
                <span class="text-0193a1 fsize25 mt-10"> ❞</span>
                <!-- <img :src="quotesImgclose" alt="quotesimg" class="w-4 h-4" /> -->
              </p>
              <div class="mx-auto text-center">
                <img
                  :src="`${$imageURL}/${item.image}`"
                  class="mt-6 rounded-full w-20 h-20 border-user mx-auto object-fill"
                  alt=""
                />
                <p class="pt-3 font-normal fsize14px text-black uppercase">
                  {{ item.name }}
                </p>
                <p class="text-sm pt-1 clr777 font-light">
                  {{ item.profession }}
                </p>
                <p class="text-sm pt-1 clr777 font-light">
                  {{
                    `${new Date(item.createdAt).toLocaleString("en-IN", {
                      month: "long",
                    })},
                    ${new Date(item.createdAt).toLocaleString("en-IN", {
                      year: "numeric",
                    })}`
                  }}
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>

        <div
          class="swiper-pagination cust-posi"
          slot="pagination"
          id="paginationdots2"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import "swiper/dist/css/swiper.min.css";
import Testimonialpopup from "./Testimonialpopup.vue";
import TestimonialDetailsPopup from "./TestimonialDetailsPopup";
export default {
  components: {
    swiper,
    swiperSlide,
    TestimonialDetailsPopup,
    Testimonialpopup,
  },
  data() {
    return {
      isLeaveActive: false,
      selectedTesimonial: {},
      selectTesimonial: {},
      quotesImgopen: require("../../../assets/images/comma.png"),
      quotesImgclose: require("../../../assets/images/commaclose.png"),
      // testimonials: [
      //   {
      //     id: "01",
      //     quotesImg: require("../../../assets/images/comma.png"),
      //     text: "I had not even thought about a role called Caregiver, until you started talking about Caregiver Saathi! Honestly speaking, I had never felt that caretaking is a job in itself and how important it is in everyone’s life but when it comes to taking care of people fighting diseases, critical illnesses and behavioural issues, the same role of caregiving squeezes out our energy without even we realising it !",
      //     userImg: require("../../../assets/images/PicturesSet/Testimonials/madhavi.jpeg"),
      //     name: "Madhavi",
      //     description: "Active Caregiver",
      //     html: `<p class="">I had not even thought about a role called Caregiver, until you started talking about Caregiver Saathi!</p><p>Honestly speaking, I had never felt that caretaking is a job in itself and how important it is in everyone’s life but when it comes to taking care of people fighting diseases, critical illnesses and behavioural issues, the same role of caregiving squeezes out our energy without even we realising it !</p><p>Last few months have been quite unexpectedly strenuous and painful, with my mom being hospitalised with a heart failure and various other complications associated with age . With one family member seriously ill, the entire family has to cope up with an entirely different routine of hospital visits and attending to the daily chores too and needs a strong moral support to take care of the ailing person without making the person feel guilty or bad for their illness . It’s like caregivers need to carry a very positive attitude and carry a pleasant mood when with the ailing person . Infact the moods /feelings of caregivers are easily carried to the ailing person . This has been my experience.</p><p>It's because of you with Caregiver Saathi that I realised how important it is to take care of ourselves so we can care for others even better !</p><p>Over the last few years, I have experienced that some souls chose me in their last phase and my journey with them has been a great learning and an enriching experience. Its a feeling of gratitude and blessing that I could be of service to these souls . I feel fortunate if these souls get some solace and peace in the service . For any little service I could do, I am grateful to the Lord for the opportunity.</p><p>Bhavana, its because of you and Caregiver Saathi that I realised how important it is to take care of ourselves so we can care for others even better !</p><p>Now I take time for myself to relax a bit, read and unwind without a bit of guilt . This me time I focus on empowering myself so I can be a greater support as a caregiver . This has helped me develop a more positive and happier outlook towards my role as a Caregiver.</p><p class="font-bold text-black text-lg my-2">Thank you very much Bhavana.
      // </p><p>If I can be of any help to people, I will be more than happy to serve.</p>`,
      //   },
      //   {
      //     id: "02",
      //     quotesImg: require("../../../assets/images/comma.png"),
      //     text: "It was early in 2017 as a coach on the Self Expression and Leadership program with Landmark Education I discovered that I wanted to do something about the sick and injured animals on my streets. Till then the only thing I did was cry when I saw one and pretty much feel guilty about not being able to do anything.",
      //     userImg: require("../../../assets/images/Rashmi Bal.png"),
      //     name: " Rashmi Bal",
      //     description: "Caregiver",
      //     html: ` <p class="">It was early in 2017 as a coach on the Self Expression and Leadership program with Landmark Education I discovered that I wanted to do something about the sick and injured animals on my streets. Till then the only thing I did was cry when I saw one and pretty much feel guilty about not being able to do anything.<p>My own coach in the program egged me on to take it up as a project and stop being emotional about it. Initially I was very impressed on how I went about getting know-how. One thing led to another and slowly I got immersed in this new world of animal welfare.</p> <p>The first few rescues gave me a lot of satisfaction, until people started tagging me and I soon became overwhelmed with the state of street animals in the city and despair in not being able to do much.Slowly I got drawn towards an abyss and started questioning myself, money, society god, life, existence, relationships everything......Deeply troubling thoughts started plaguing me should i complete the cake order/cook dinner/pick up my son from his bus stop or drop everything and run to rescue; should I eat out or use the money to feed street dogs........ I was in deep turmoil and utterly depressed.</p> <p>That Dussehra I went home and discussed this with family and friends literally sounding like a broken record. It was something my father Suryakant Bal , my sister in law Medha Khare Jatar and fellow rescuer Poonam Kunwar said that jolted me and helped garner direction, however I had lost the strength to move on.</p> <p>One day it flashed to me that my friend Bhavana Issar had started an NGO Caregiver Saathi which provided counseling to caregivers. Now wasn't I a caregiver too.. So what if it was to dogs and I reached out to her.</p> <p>She set up a couple of sessions in which WE worked with ME. Slowly yet surely I found my sanity returning back. In those sessions the coaching she gave me, highlighting areas where I was being stopped or stopping myself gave me strength to continue work in this area in whichever way feasible</p> <p>Thank you Bhavana and @caregiver saathi for patiently being there when I needed it the most... You have played a huge part in me not giving up.</p> <p>Today I have a group of fellow rescuers in my community, its small but together we are taking steps ahead....</p> <p>If you're a caregiver, or a well-wisher of a caregiver, you can nudge them to seek out the support they need.... </p>`,
      //   },
      //   {
      //     id: "03",
      //     quotesImg: require("../../../assets/images/comma.png"),
      //     text: "I joined Caregiver Saathi because I personally lived with a caregiver and a chronically ill patient for three years. That is why I very well know the importance of the awareness of the mental health of the caregivers.",
      //     userImg: require("../../../assets/images/Saloni Shah.png"),
      //     name: " Saloni Shah",
      //     description: "Volunteer",
      //     html: `<p class="">I joined Caregiver Saathi because I personally lived with a caregiver and a chronically ill patient for three years. That is why I very well know the importance of the awareness of the mental health of the caregivers. </p> <p>And this organization resonates with me because I understand how neglected and in the shadows are the caregivers. This organization is going to help me reach out to as many people I can, making them aware of the needs.</p>`,
      //   },
      //   {
      //     id: "04",
      //     quotesImg: require("../../../assets/images/comma.png"),
      //     text: "We would like to express our profound gratitude to you for helping us complete the 3-module workshop on Caregiving and its importance, for our people in Accenture Operations.",
      //     userImg: require("../../../assets/images/corporate-log/Accenture-logo.png"),
      //     name: "Accenture",
      //     description: "Corporate Partner",
      //     html: `<p class="">“We would like to express our profound gratitude to you for helping us complete the 3-module workshop on Caregiving and its importance, for our people in Accenture Operations.</p> <p>This was the first time that we were able to introduce a program of such unique nature for our employees, and we have been getting great feedback from attendees. <p> We greatly appreciate your time and contributions towards making this program a success and helping us create awareness on the relevance of caregivers in today’s age and the crucial role they play. Most importantly, we are happy to have been able to highlight the various dimensions of caregiving and hope that this is a stepping stone towards increasing our employees' understanding of caregiving and caregivers better.”</p>`,
      //   },
      //   {
      //     id: "05",
      //     quotesImg: require("../../../assets/images/comma.png"),
      //     text: "Great material shared, very intimate group with high level of expertise so that the group discussions were great learning material.",
      //     userImg: require("../../../assets/images/Sebati_Iyengar.jpg"),
      //     name: "Sebati Iyengar",
      //     description: "Coach on Caregiver Coaching Program",
      //     html: `<p class="">Great material shared, very intimate group with high level of expertise so that the group discussions were great learning material.</p>`,
      //   },
      //   {
      //     id: "06",
      //     quotesImg: require("../../../assets/images/comma.png"),
      //     text: "We need to step back and evaluate our training, as we are not getting a holistic perspective. I think we need to educate both the community and doctors, so that we become a more compassionate lot. It has to be person-centric and not patient-centric care, with a focus on the art of healing. Look beyond the patient and also address the burden a caregiver is going through.”",
      //     userImg: require("../../../assets/images/team/Rajam Iyer.jpeg"),
      //     name: "Dr.Rajam Iyer",
      //     description:
      //       "Pulmonologist, Palliative care physician & Active caregiver",
      //     html: `<p class="">“We need to step back and evaluate our training, as we are not getting a holistic perspective. I think we need to educate both the community and doctors, so that we become a more compassionate lot. It has to be person-centric and not patient-centric care, with a focus on the art of healing. Look beyond the patient and also address the burden a caregiver is going through.”</p>`,
      //   },
      // ],
      //Sebati_Iyengar
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2.2,
        spaceBetween: 170,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        roundLengths: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 3,
          slideShadows: true,
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          505: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        pagination: {
          el: "#paginationdots2",
        },
      },
      isDetailsActive: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    ...mapState("testimonial", {
      testimonials: "testimonial",
      redirect: "redirect",
    }),
  },
  watch: {
    testimonials() {
      if (this.$route.query.scroll === "testimonial") {
        const el = document.getElementById("testimonialjoinus");
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
  },
  methods: {
    handleLeave(val = false, item = {}) {
      if (!sessionStorage.getItem("token")) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      // console.log("Click");
      this.isLeaveActive = val;
      this.selectTesimonial = item;
    },
    toggleDetails(val = false, item = {}) {
      // console.log("Click");
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    mouseover() {
      this.swiper.autoplay.pause();
    },
    mouseleave() {
      // console.log("Leave");
      this.swiper.autoplay.run();
    },
    async getAllTestimonial() {
      let loader;
      try {
        let payload = {
          limit: 50,
          status: "Accept",
        };
        // loader = this.$loading();
        const allTestimonial = await this.$store.dispatch(
          "testimonial/getAllTestimonial",
          payload
        );

        // loader.close();

        // console.log(this.testimonials);
      } catch (error) {
        console.log(error);
        // loader.close();
      }
    },
  },
  async mounted() {
    // console.log(this.redirect, "redirect");
    if (this.redirect === true) {
      const el = document.getElementById("testimonialjoinus");
      // console.log(el, "el");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      this.$store.commit("testimonial/REDIRECT_TESTIMONIAL", false);
      // console.log(this.redirect, "redirect");
    }
    await this.getAllTestimonial();
  },
};
</script>

<style lang="scss" scoped>
.example-3d {
  width: 100%;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 430px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    background-position: center;
    background-size: cover;
    color: white;
    border: 10px solid #e9ddfa;
    border-radius: 25px;
    background-color: white !important;
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  }
}
.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.cust-bg .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(146, 146, 146, 0.2)),
    to(rgba(0, 0, 0, 0))
  ) !important ;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}
.testimonal-h650px {
  height: 650px;
}
@media (max-width: 641px) {
  .cust-posi {
    padding-top: 10px !important;
  }
}
p.wquote::before {
  background-image: url("../../../assets/images/comma.png");
  content: "";
}
p.wquote::after {
  background-image: url("../../../assets/images/commaclose.png");
  content: "";
}
</style>
